import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, xs: 24 };

const TaxLoss = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);

    return (
        <Row gutter={[16, 16]}>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.taxLossViewable', { returnObjects: true })}
                    disabled={disabled}
                    name="taxLoss.isViewable"
                />
            </Col>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.taxLossEditable', { returnObjects: true })}
                    disabled={disabled}
                    name="taxLoss.isEditable"
                />
            </Col>
        </Row>
    );
};

export default TaxLoss;
